import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ToastrService } from 'ngx-toastr';
import { ObjectAfleveradres, ObjectData } from 'src/app/shared/model/object';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
// import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { NewFactuurComponent } from './new-factuur/new-factuur.component';
import { NewOfferteComponent } from './new-offerte/new-offerte.component';
import { ChangeNumberComponent } from './change-number/change-number.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/general/confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'app-object-edit',
  templateUrl: './object-edit.component.html',
  styleUrls: ['./object-edit.component.less']
})
export class ObjectEditComponent implements OnInit {


  data: ObjectData = null;
  relaties: any = null;
  contactpersonen: any = null;
  medewerkers: any = null;
  fasen = [];
  routeid = 0;


  constructor(private objectService: ObjectenService,
              private relatiesService: RelatiesService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private dialog: MatDialog,
              private location: Location,
              private toastr: ToastrService) { }

  @Input() objectid;

  ngOnInit() {
    this.objectid = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    if (this.objectid) {
      this.loadData();
    }
    this.routeid = this.objectid;
    this.relatiesService.getActiveRelatieList().subscribe(data => {
      this.relaties = data;
    })
    this.objectService.getMedewerkers().subscribe(data => {
      this.medewerkers = data;
    })
    this.objectService.getFasen().subscribe(data=> this.fasen = data)

  }


  loadData() {
    if (this.routeid == 0) {
      this.objectService.getObject(this.objectid).subscribe(data => {
        if (data == null) return;
        this.data =  data as ObjectData;
        this.objectid =  this.data.ID;
        //this.data.InvoerDatum = moment(data.invoerdatum).format("DD/MM/YYYY");
        this.relatiesService.getContactpersonen(this.data.BedrijfNummer).subscribe(contactpersonen => {
          this.contactpersonen = contactpersonen;
        })
      })
    } else {
      this.routeid = 0;
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    this.loadData();
    if (!this.data) return;
    this.location.go("/objecten/"+ changes.objectid.currentValue);
  }

  save() {
    this.objectService.saveObject(this.objectid,this.data).subscribe(() => {
      this.toastr.success("", "Opgeslagen");
    } )
  }
  add() {
    this.router.navigateByUrl('/objecten/add');
  }

  delete() {
    const message = `Weet je zeker dat je dit wilt doen?`;

    const dialogData = new ConfirmDialogModel("Bevestig verwijdering", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      const result = dialogResult;
      if (result) {
        this.objectService.deleteObject(this.data.ID).subscribe(data => {
          this.toastr.show("Object verwijderd");
          window.location.href = "/objecten";
        })
      }
      
    });

  }

  copy() {
    this.objectService.postCopyObject(this.data.ID).subscribe(result => {
      window.open("/objecten/" + result.NewObjectID,"_blank");
    })
  }

  offerte() {
    let dialogRef = this.dialog.open(NewOfferteComponent, {
      height: '300px',
      width: '400px',
    });

    dialogRef.afterClosed().subscribe(result => {
      const offertenummer = result.offertenummer;
      this.objectService.postMaakOfferte(this.data.ID,offertenummer).subscribe(result => {
        console.log(result);
        window.open("/offerte/" + result.OfferteID,"_blank");
      })
    });
  }

  factuur(){
    let dialogRef = this.dialog.open(NewFactuurComponent, {
      height: '300px',
      width: '400px',
    });

    dialogRef.afterClosed().subscribe(result => {
      const factuurnummer = result.factuurnummer;
      this.objectService.postMaakFactuur(this.data.ID,factuurnummer).subscribe(result => {
        window.open("/factuur/" + result.FactuurID,"_blank");
      })
    });
  }

  afleverbon() {
    this.objectService.getObjectAfleveradresList(this.data.ID).subscribe(data => {
        const objectafleveradreslist = (data as Array<ObjectAfleveradres>);
        if (objectafleveradreslist.length == 0) {
          this.toastr.error("Geen afleveradressen gedefinieerd", "Ongeldig", {
            timeOut: 0,
          });
          return false;
        }
        const AfleverAdresID = objectafleveradreslist[0].AfleverAdresID;
        this.objectService.getAfleverbon(this.data.ID,AfleverAdresID).subscribe(result => {
          window.open(result.url,"_blank");
        });
    })

  }

  changeObjectNr() {
    const dialogRef = this.dialog.open(ChangeNumberComponent, {
      height: '300px',
      width: '400px',
       data: {
        objectnummer: this.data.ObjectNummer,
        volgnummer: this.data.ObjectSerieNr
      }
    }
    );

    dialogRef.afterClosed().subscribe(result => {
      const objectnummer = result.objectnummer;
      const volgnummer = result.volgnummer;
      this.data.ObjectNummer = objectnummer;
      this.data.ObjectSerieNr = volgnummer;
    });
  }
}
